<div class="flex_center">
	<mat-icon color="warn" class="margin_right_very_small">close</mat-icon>
	<p class="color_black_inactive" [innerHTML]="captionInnerHtml | safeHtml"></p>
</div>